import React from 'react'
import create from 'zustand'
import { shopModel } from '../Axios/AxiosConfig';

const WishlistStore = create((set, get) => ({
    WishlistItems: [],
    isWishlistLoading: true,

    addWishlist: async (id) => {
        try {

            const res = await shopModel.post(`/api/v1/wishlist/items/${id}`)

            if (res.status === 200) {
                set(() => ({
                    WishlistItems: res.data,
                    isWishlistLoading: false
                }));
            }

        }
        catch (err) {
            console.log(err?.response?.data)
        }
    },


    removeWishlist: async (id) => {
        try {

            const res = await shopModel.delete(`/api/v1/wishlist/items/${id}`)

            if (res.status === 200) {
                set(() => ({
                    WishlistItems: res.data,
                    isWishlistLoading: false
                }));
            }

        }
        catch (err) {
            console.log(err?.response?.data)
        }
    },

    getWishlistItems: async () => {
        try {

            const res = await shopModel.get(`/api/v1/wishlist`)

            if (res.status === 200) {
                set(() => ({
                    WishlistItems: res.data,
                    isWishlistLoading: false
                }));
            }

        }
        catch (err) {
            console.log(err?.response?.data)
        }
    }

}))

export default WishlistStore